const PREFIX = 'MSTeams'

export const FETCH_DATA = `${PREFIX}/FETCH_DATA`
export const SET_IS_ACTIVE = `${PREFIX}/SET_IS_ACTIVE`
export const SET_SLACK_CHANNEL = `${PREFIX}/SET_SLACK_CHANNEL`
